<h2 mat-dialog-title style="margin-bottom: 20px;">Privilege Log</h2>
<mat-dialog-content>

  <div style="display: flex; flex-direction: column; gap: 10px;">
    <div style="display: flex;" *ngFor="let file of fileList">
      <div class="item primary-item" *ngIf="file.type === 'outgoing-production-withheld-log'" (click)="downloadFile(file)">
        <div style="display: flex; flex-direction: row; align-items: center; gap: 5px;">
          <mat-icon>download</mat-icon>
          <div>Download Excel File</div>
        </div>
      </div>
      <div class="item" (click)="delete(file)">
        <mat-icon>delete</mat-icon>
      </div>
    </div>
    <div class="item" *ngIf="shouldShowCreateWithheldLog" (click)="createWithheldLog()">
      <mat-icon>add_to_queue</mat-icon>
      <div>Queue step to create Excel export</div>
    </div>
  </div>

</mat-dialog-content>
<mat-dialog-actions style="place-content: stretch flex-end; align-items: stretch; flex-direction: row; box-sizing: border-box; display: flex;">
  <button mat-raised-button color="secondary" mat-dialog-close>Cancel</button>
</mat-dialog-actions>
